module.exports = __webpack_public_path__ + "static/media/how-qr-works-1.761d6a3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/how-qr-works-1.png
// module id = 364
// module chunks = 3